module.exports = __webpack_public_path__ + "img/cc_icon.2506d06a.png";